import { keepPreviousData, queryOptions } from '@tanstack/react-query';

import { getProductVisibilityRoles } from '@apple/features/auth/api/roles';
import type { ProductKey } from '@apple/features/product/models/product';

import { getProduct, getProductAudits } from '../api/management';

export const productQueryKeys = {
	product: (itemId: ProductKey) => ['product', itemId],
	audit: (itemId: ProductKey) => ['product', itemId, 'audit'],
	visibility: ['products', 'visibility'],
};

export const channelProductQueryOptions = {
	product: (itemId: ProductKey) =>
		queryOptions({
			queryKey: productQueryKeys.product(itemId),
			queryFn: () => getProduct(itemId),
			staleTime: 5 * 60 * 1000, // 5 minutes
		}),
	audit: (itemId: ProductKey) =>
		queryOptions({
			queryKey: productQueryKeys.audit(itemId),
			queryFn: () => getProductAudits(itemId),
			placeholderData: keepPreviousData,
			staleTime: 5 * 60 * 1000, // 5 minutes
			initialDataUpdatedAt: 0,
			initialData: [],
		}),
	visibility: queryOptions({
		queryKey: productQueryKeys.visibility,
		queryFn: getProductVisibilityRoles,
		staleTime: Infinity,
	}),
};
